import React, { useState } from 'react';

const AdminHeader = ({ admin, onLogout, onToggleSidebar }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <header className="admin-header">
      <div className="header-left">
        <button className="sidebar-toggle" onClick={onToggleSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h2>Welcome back, {admin?.name || admin?.email?.split('@')[0]}</h2>
      </div>

      <div className="header-right">
        <div className="admin-profile" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="profile-avatar">
            {(admin?.name || admin?.email || 'A')[0].toUpperCase()}
          </div>
          <div className="profile-info">
            <span className="profile-name">{admin?.name || admin?.email}</span>
            <span className="profile-role">{admin?.role || 'Administrator'}</span>
          </div>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>

          {showDropdown && (
            <div className="profile-dropdown">
              <button className="dropdown-item" onClick={onLogout}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;